var _path, _circle, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _rect2, _path8, _rect3, _rect4, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10Culture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3087 32.1864C22.4237 31.985 22.6059 31.831 22.8207 31.7438C28.6776 29.367 32.8079 23.6219 32.8079 16.912C32.8079 8.07546 25.6444 0.912018 16.8079 0.912018C7.97131 0.912018 0.807861 8.07546 0.807861 16.912C0.807861 23.708 5.04492 29.5144 11.0215 31.8337C11.2428 31.9195 11.4307 32.0759 11.5485 32.282L15.1648 38.6106C15.9325 39.9542 17.8699 39.9542 18.6377 38.6106L22.3087 32.1864Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8079,
    cy: 16.912,
    r: 13.5,
    fill: "#291F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2871 8.22352C16.3559 8.17296 16.4389 8.14569 16.5242 8.14569H17.0908C17.1762 8.14569 17.2594 8.17304 17.3282 8.22374L24.94 13.836C25.0423 13.9114 25.1026 14.0309 25.1026 14.1579V14.3817C25.1026 14.6026 24.9235 14.7817 24.7026 14.7817H8.91269C8.69178 14.7817 8.5127 14.6026 8.5127 14.3817V14.147C8.5127 14.0198 8.57318 13.9002 8.67561 13.8248L16.2871 8.22352Z",
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2981 8.20239L25.1028 13.9655V14.7913H20.1258V13.9543L17.2981 8.20239Z",
    fill: "#ABA9C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.34229,
    y: 14.7816,
    width: 14.9309,
    height: 0.829497,
    rx: 0.414748,
    fill: "#E7E6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34229 14.7816H24.2732V15.1964H9.34229V14.7816Z",
    fill: "#ABA9C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34229 22.6471C9.34229 22.4262 9.52137 22.2471 9.74229 22.2471H23.8732C24.0941 22.2471 24.2732 22.4262 24.2732 22.6471V23.0766H9.34229V22.6471Z",
    fill: "#4841A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4897 22.2471H23.4437C23.9018 22.2471 24.2732 22.6185 24.2732 23.0766V23.0766H20.1257L13.4897 22.2471Z",
    fill: "#353071"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 23.4766C8.5127 23.2557 8.69178 23.0766 8.9127 23.0766H24.7026C24.9235 23.0766 25.1026 23.2557 25.1026 23.4766V24.3356C25.1026 24.5565 24.9235 24.7356 24.7026 24.7356H8.91269C8.69178 24.7356 8.5127 24.5565 8.5127 24.3356V23.4766Z",
    fill: "#E7E6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1716,
    y: 15.6112,
    width: 3.31799,
    height: 6.63597,
    fill: "#E7E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1716 15.6112H13.4896V20.1734L10.1716 17.2702V15.6112Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1487,
    y: 15.6112,
    width: 3.31799,
    height: 6.63597,
    fill: "#E7E6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1255,
    y: 15.6112,
    width: 3.31799,
    height: 6.63597,
    fill: "#E7E6F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1487 15.6112H18.4667V20.1734L15.1487 17.2702V15.6112Z",
    fill: "#ABA9C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1255 15.6112H23.4435V20.1734L20.1255 17.2702V15.6112Z",
    fill: "#ABA9C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Culture);
export default __webpack_public_path__ + "static/media/10_culture.7a50c2d6b7a317fca05183c187d60237.svg";
export { ForwardRef as ReactComponent };